import React from "react";
import { Input, Col, Row, Form } from "antd";

const { Item } = Form;

const Name = ({ form }) => {
  return (
    <Row span={24}>
      <Col xs={8} md={4}>
        <h4>Name</h4>
      </Col>
      <Col xs={24} md={10}>
        <Row gutter={24}>
          <Col xs={10} md={10}>
            <Item name="fNamePrefix">
              <Input
                size="large"
                name="fNamePrefix"
                style={{ borderRadius: 8 }}
                placeholder="Prefix"
              />
            </Item>
          </Col>
          <Col xs={14} md={13}>
            <Item name="fName">
              <Input
                size="large"
                name="fName"
                style={{ borderRadius: 8 }}
                placeholder="First Name"
              />
            </Item>
          </Col>
        </Row>
      </Col>
      <Col xs={24} md={10}>
        <Row gutter={24} justify="space-between">
          <Col xs={14} md={13}>
            <Item name="lName">
              <Input
                size="large"
                name="lName"
                style={{ borderRadius: 8 }}
                placeholder="Last Name"
              />
            </Item>
          </Col>
          <Col xs={10} md={10}>
            <Item name="lNameSuffix">
              <Input
                size="large"
                name="lNameSuffix"
                style={{ borderRadius: 8 }}
                placeholder="Suffix"
              />
            </Item>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Name;
